import { useCallback, useEffect, useRef } from "react";

const useTimeout = () => {
  const timeoutsRef = useRef(new Set());

  const setTimeoutFn = useCallback((callback, delay = 200) => {
    const timeoutId = window.setTimeout(() => {
      timeoutsRef.current.delete(timeoutId);
      callback();
    }, delay);

    timeoutsRef.current.add(timeoutId);

    return timeoutId;
  }, []);

  const clearTimeoutFn = useCallback((timeoutId) => {
    if (timeoutId == null) return;

    window.clearTimeout(timeoutId);
    timeoutsRef.current.delete(timeoutId);
  }, []);

  const clearAllTimeouts = useCallback(() => {
    timeoutsRef.current.forEach((timeoutId) => {
      window.clearTimeout(timeoutId);
    });

    timeoutsRef.current.clear();
  }, []);

  // Clear all pending timeouts when component unmounts
  useEffect(() => {
    return () => {
      clearAllTimeouts();
    };
  }, [clearAllTimeouts]);

  return {
    setTimeout: setTimeoutFn,
    clearTimeout: clearTimeoutFn,
    clearAllTimeouts,
  };
};

export default useTimeout;